module.exports = __webpack_public_path__ + "_assets/img/empty-notification.b45a891a.svg";